export const BOOKING_QUESTIONS_LEARN_MORE_HREFS = {
  BOOKING_QUESTIONS:
    "https://support.exlyapp.com/en/support/solutions/articles/84000392258-how-to-add-booking-questions-to-an-offering-",
  BOOKING_QUESTIONS_VIDEO: "https://www.youtube-nocookie.com/embed/jY0thFLgYAM",
};

const constants = {
  form_data: {
    question: "question",
    type: "type",
    required: "is_mandatory",
  },

  form_header: {
    question: "Question",
    type: "Answer Type",
    action: "Action",
    isMandatory: "Is mandatory",
  },
};
export default constants;

export const TABLE_CONFIG_CONSTANTS = {
  EMPTY_FIELD: "N/A",
  IS_MANDATORY: "is_mandatory",
  LISTING_SOURCE: "listing__type",
};
